module.exports = __webpack_public_path__ + "media/14-Basirat_Naphew_Testimonial.d76254dd.mp3";